import { supabase } from '../../../src/lib/supabase';

export async function aprovarUg(ugId: string): Promise<void> {
  const { error } = await supabase.rpc('aprovar_ug', { p_ug_id: ugId });
  if (error) throw error;
}

export async function rejeitarUg(ugId: string, motivo: string): Promise<void> {
  const { error } = await supabase.rpc('rejeitar_ug', { p_ug_id: ugId, p_motivo: motivo });
  if (error) throw error;
}
